import React from 'react';
import { useTranslation } from 'react-i18next';

import { WorkforceNumbersWidgets } from '@/modules/home';

import Worker from '~/images/shared/Worker.svg';

const WorkforceNumbers = () => {
  const { t } = useTranslation('common');
  return (
    <section className='flex flex-col gap-7'>
      <div className='flex items-center gap-2 text-20 text-primary-default'>
        <Worker width='24' height='24' />
        <h3 className='font-bold leading-none'>{t('the-workforce')}</h3>
      </div>
      <WorkforceNumbersWidgets />
    </section>
  );
};
export { WorkforceNumbers };
